import { isRouteErrorResponse, useRouteError } from 'react-router'
import { ErrorState } from './ErrorState'
import { NotFoundState } from './NotFoundState'

export function RouteErrorState() {
  const error = useRouteError()

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <NotFoundState
        message="Página não encontrada."
        backTo="/dashboard"
        backLabel="Ir ao dashboard"
      />
    )
  }

  return (
    <ErrorState
      title={
        isRouteErrorResponse(error) && error.status === 403
          ? 'Acesso negado'
          : 'Falha ao carregar a página'
      }
      message="Verifique a conexão e tente novamente."
      retry={() => window.location.reload()}
    />
  )
}
